import { useEffect, useRef, useState } from 'react';
import './style/ToolsPanel.css';
import desmosIcon from '../images/desmosIcon.png';
import referenceIcon from '../images/referenceIcon.png';
import referenceSheet from '../images/referenceSheet.png';
import closeIcon from '../images/closeTool.png';
import openIcon from '../images/openTool.png';

function ToolsPanel({ onReady, resetKey, onCollapse }) {
  const containerRef = useRef(null);
  const scriptRef = useRef(null);
  const calcRef = useRef(null);
  const [sidebarOption, setSidebarOption] = useState(null);
  const [panelWidth, setPanelWidth] = useState(() => {
    return (35.1);
  });
  const [collapsed, setCollapsed] = useState(false);
  const isDragging = useRef(false);
  const [isResizing, setIsResizing] = useState(false);
  const lastOption = useRef('desmos');

  const handleSidebarClick = (option) => {
    const next = sidebarOption === option ? null : option;
    setSidebarOption(next);
    if (next) lastOption.current = next;
    if (next === 'desmos' && calcRef.current) {
      calcRef.current.updateSettings({ showGrid: true });
    }
  };

  const handleClose = () => {
    setCollapsed(true);
    setSidebarOption(null);
    if (onCollapse) onCollapse(true);
  };

  const handleOpen = () => {
    setCollapsed(false);
    if (onCollapse) onCollapse(false);
    const restore = lastOption.current || 'desmos';
    setSidebarOption(restore);
    if (restore === 'desmos' && calcRef.current) {
      calcRef.current.updateSettings({ showGrid: true });
    }
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    isDragging.current = true;
    setIsResizing(true);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    const vw = window.innerWidth;
    const newWidth = (e.clientX / vw) * 100;
    if (newWidth >= 20 && newWidth <= 70) {setPanelWidth(newWidth);}
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    setIsResizing(false);
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };

  useEffect(() => {
    if (calcRef.current) {
      calcRef.current.setBlank();
    }
  }, [resetKey]);

  useEffect(() => {
    const loadDesmos = () => {
      if (!containerRef.current) return;
      if (window.Desmos) {
        calcRef.current = window.Desmos.GraphingCalculator(containerRef.current);
        if (onReady) onReady();
        return;
      }
      scriptRef.current = document.createElement('script');
      scriptRef.current.src = 'https://www.desmos.com/api/v1.11/calculator.js?apiKey=45188bbe8e564f4790102b97bed87bba';
      scriptRef.current.async = true;
      scriptRef.current.onload = () => {
        calcRef.current = window.Desmos.GraphingCalculator(containerRef.current);
        if (onReady) onReady();
      };
      document.body.appendChild(scriptRef.current);
    };
    loadDesmos();
    return () => {
      if (calcRef.current && typeof calcRef.current.destroy === 'function') { calcRef.current.destroy(); }
      else if (containerRef.current) { containerRef.current.innerHTML = ''; }
      if (scriptRef.current && scriptRef.current.parentNode) { scriptRef.current.parentNode.removeChild(scriptRef.current); }
    };
  }, []);

  return (
    <>
      <div className={`tools-panel ${collapsed ? 'collapsed' : ''} ${isResizing ? 'resizing' : ''}`} style={collapsed ? {} : { width: `${panelWidth}%` }}>
        <div className='tools-sidebar'>
          <img src={desmosIcon} alt="Desmos" onClick={() => collapsed ? handleOpen() : handleSidebarClick('desmos')} />
          <img src={referenceIcon} alt="Reference Sheet" onClick={() => collapsed ? handleOpen() : handleSidebarClick('reference')} />
          <img src={collapsed ? openIcon : closeIcon} onClick={() => collapsed ? handleOpen() : handleClose()} className='close-icon' />
        </div>
        <div className='tools-content' style={{ display: collapsed ? 'none' : 'flex' }}>
          <div className='desmos-calculator' style={{ display: sidebarOption === 'reference' ? 'none' : 'block' }} ref={containerRef} />
          <div className='reference-sheet-viewer' style={{ display: sidebarOption === 'reference' ? 'block' : 'none' }}>
            <img src={referenceSheet} alt="Reference Sheet" />
          </div>
          <div className='tools-panel-resize' onMouseDown={handleMouseDown} />
        </div>
      </div>
    </>
  );
}

export default ToolsPanel;
